import ProfileIcon from "../../../assets/icons/profile.svg";
import {
  acceptChannelRequest,
  declineChannelRequest,
  fetchChannelRequests,
} from "../../../redux/slices/businessSlice";
import ColorProfile from "../../../assets/images/color_profile.svg";
import { FiInbox } from "react-icons/fi";
import EmptyState from "../widgets/EmptyState";
import {
  React,
  useState,
  useDispatch,
  useSelector,
  useEffect,
} from "../../../globals/imports.js";

const RequestTab = () => {
  const dispatch = useDispatch();
  const business = useSelector((state) => state.business);
  const [page, setPage] = useState(1);
  const PER = 10;
  const reqs = business.requests || [];
  const totalPages = Math.max(1, Math.ceil(reqs.length / PER));
  const pageReqs = reqs.slice((page - 1) * PER, page * PER);

  useEffect(() => {
    dispatch(fetchChannelRequests());
  }, []);

  useEffect(() => {
    if (page > totalPages) setPage(totalPages);
  }, [totalPages, page]);

  // Plain objects — postRequestAuthenticated sends JSON, and the accept/decline
  // routes are JSON-only (no multer), so a FormData body would never be parsed.
  const handleAcceptChannelRequest = (channelId, userId) => {
    dispatch(acceptChannelRequest({ channelId, userId }));
  };

  const handleDeclineChannelRequest = (channelId, userId) => {
    dispatch(declineChannelRequest({ channelId, userId }));
  };

  return (
    <div className="mx-auto max-w-4xl px-4 py-7 sm:px-6 lg:px-8">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-theme-secondaryText">
          Channel requests
        </h1>
        <p className="mt-1 text-sm text-theme-placeholder">
          People asking to join your invite-only channels. Accept or decline.
        </p>
      </div>

      {reqs.length > 0 ? (
        <div className="flex flex-col divide-y divide-theme-chatDivider rounded-2xl border border-theme-chatDivider bg-theme-secondaryBackground p-2">
          {pageReqs.map((request) => (
            <div
              key={request._id}
              className="flex flex-row items-center justify-between gap-3 px-3 py-3"
            >
              <div className="flex min-w-0 flex-row items-center">
                {request.logo ? (
                  <img
                    src={request.logo}
                    alt="profile-icon"
                    className="h-11 w-11 rounded-md object-cover"
                  />
                ) : request.color_logo ? (
                  <div
                    className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full"
                    style={{ backgroundColor: request?.color_logo }}
                  >
                    <img src={ColorProfile} alt="" className="h-7 w-7" />
                  </div>
                ) : (
                  <img
                    src={ProfileIcon}
                    alt="profile-icon"
                    className="h-11 w-11 rounded-md object-cover"
                  />
                )}
                <div className="ml-3 flex min-w-0 flex-col">
                  <p className="truncate text-sm font-medium text-theme-secondaryText">
                    {request.username}
                  </p>
                  <p className="truncate text-xs italic text-theme-placeholder">
                    {request.channel_name}
                  </p>
                </div>
              </div>
              <div className="flex flex-shrink-0 flex-row items-center gap-2.5">
                <button
                  className="rounded-lg bg-theme-secondaryText px-4 py-2 text-sm font-medium text-theme-primaryBackground"
                  onClick={() =>
                    handleAcceptChannelRequest(request.channel_id, request._id)
                  }
                >
                  Accept
                </button>
                <button
                  className="rounded-lg border border-theme-secondaryText px-4 py-2 text-sm font-medium text-theme-secondaryText"
                  onClick={() =>
                    handleDeclineChannelRequest(request.channel_id, request._id)
                  }
                >
                  Decline
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <EmptyState
          icon={FiInbox}
          title="No pending requests"
          subtitle="When someone asks to join an invite-only channel, it appears here to approve or decline."
        />
      )}

      {reqs.length > PER && (
        <div className="mt-4 flex items-center justify-between">
          <span className="text-xs text-theme-placeholder">
            Page {page} of {totalPages} · {reqs.length} requests
          </span>
          <div className="flex items-center gap-2">
            <button
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              disabled={page <= 1}
              className="rounded-lg border border-theme-chatDivider px-3 py-1.5 text-xs font-semibold text-theme-primaryText transition-colors hover:bg-theme-tertiaryBackground disabled:opacity-40"
            >
              Prev
            </button>
            <button
              onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
              disabled={page >= totalPages}
              className="rounded-lg border border-theme-chatDivider px-3 py-1.5 text-xs font-semibold text-theme-primaryText transition-colors hover:bg-theme-tertiaryBackground disabled:opacity-40"
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RequestTab;
